// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"840a6921","102":"ff927709","195":"cba08293","222":"a393c15c","366":"cc7de573","496":"5d886b8d","897":"ebd3f887"}[chunkId] + ".chunk.js";
};